// Money helpers for the UI. Balances are stored as integer cents in the
// database (see functions/accounting.js); the UI converts at the edges only.

const USD = { style: "currency", currency: "USD" };

// Integer cents → "$1,234.56". Anything that isn't a number renders as $0.00.
export const formatCents = (cents) => {
  const n = Number(cents);
  return ((Number.isFinite(n) ? n : 0) / 100).toLocaleString("en-US", USD);
};

// Integer cents → a plain number of dollars for form fields (two decimals).
export const centsToDollars = (cents) => {
  const n = Number(cents);
  return Number.isFinite(n) ? Math.round(n) / 100 : 0;
};

// User-entered dollars (string or number) → integer cents.
//
// Works on the decimal text rather than on the float so that "4.345" rounds
// half-up to 435 instead of falling to 434 through 4.345 * 100 =
// 434.49999999999994. Accepts "$" and thousands separators; anything that
// isn't a decimal number is treated as zero.
export const dollarsToCents = (value) => {
  if (value === null || value === undefined) return 0;
  const str = String(value).trim().replace(/[$,\s]/g, "");
  if (!/^[-+]?(\d+\.?\d*|\.\d+)$/.test(str)) return 0;
  const negative = str.startsWith("-");
  const [whole = "", frac = ""] = str.replace(/^[-+]/, "").split(".");
  const wholeCents = parseInt(whole || "0", 10) * 100;
  const fracCents = Math.round(parseInt(`${frac}000`.slice(0, 3), 10) / 10);
  const cents = wholeCents + fracCents;
  return negative ? -cents : cents;
};

// Resident's net position in cents: positive is credit, negative is owed.
export const netBalanceCents = (account) =>
  (account?.credit || 0) - (account?.amountDue || 0);
